import Vue from "vue";
import store from "./store";
import router from "./router";

const layoutEngine = new Vue({
  router,
  store,

  data: function () {
    return {
      aMQBridgePrevious: [],
      aMQAccess: [],
      tResize: 0,
      windowWidth: 1000 * 3,
      inFrameSizes: ["md", "sm"],
      inFrameDevices: ["phone", "tablet"],
      iRandTrigger: 0,
      bForceDark: false,
      desktop: false,
      mobile: false,
      bIsDeepSwiper: false,
    };
  },

  mounted() {
    window.matchMedia("(prefers-color-scheme: light)") .addEventListener("change", e => e.matches && this.goLight());
    window.matchMedia("(prefers-color-scheme: dark)")  .addEventListener("change", e => e.matches && this.goDark());
  },

  computed: {
    viewMode() {
      return this.$store.hasApp;
    },
    get() {
      return this.aMQBridgePrevious;
    },
    isDesktop() {
      return this.desktop;
      // return document.body.classList.contains("desktop");
    },
    isMobile() {
      return this.mobile;
      // return document.body.classList.contains("mobile");
    },
    isStackPreviewPane() {
      if (!this.$route.meta.swiper) {
        return false;
      }
      return !this.bIsDeepSwiper;
    },
    // HACKED COS LOAD ORDER/MODULES ETC IS A MESS!
    // ******* SEE main.js for $mq parity! ********
    $mq() {
      let w = this.windowWidth;
      if (w < 450) return "sm";
      if (w < 1250) return "md";
      return "lg";
    },
    $dq() {
      // for devices ...
      let w = this.windowWidth;
      if (w < 768) return "phone"; // covers portrait + landscape phones
      if (w < 992) return "tablet"; // tablets (both iPad Mini + full)
      return "desktop"; // laptops and up
    },
    forceDark() {
      // // once the user is officially N2, revert to their choice (cos we default everyone to dark at signup...)
      // if (this.$store.isNourish2) {
      //   return false;
      // }
      return this.bForceDark;
      // return false;
    },
    isForcedMode() {
      return false // this.forceDark; // or forceLight, potentially... hence separate method..
    },
  },

  methods: {

    // have we just started the swiper... (hide the tabBar?)
    resetSwiper() {
      this.bIsDeepSwiper = false;
    },
    goDeepSwiper() {
      this.bIsDeepSwiper = true;
    },



    goDark() {
      this.bForceDark = true;
    },
    goLight() {
      this.bForceDark = false;
    },

    syncMQBridge() {
      // this.nourishDeskBounce(this.$route, 'bridge');

      this.notice("Syncing MQ Bridge...");

      let eMQBridge = document.getElementById("mq-bridge");

      if (!eMQBridge) {
        console.error("Failed to connect to MQ Bridge");
        return;
      }

      // this.error(':before - ', eMQBridge, getComputedStyle(eMQBridge, ':before').content);
      // this.error(':before - ', eMQBridge, getComputedStyle(eMQBridge, ':after').content);

      // device display size/mode etc..
      let sMQBridge = getComputedStyle(eMQBridge, ":before").content.replace(
        /^\W(.*)\W$/,
        "$1"
      );

      let aMQBridge = sMQBridge.split(" ");

      if (aMQBridge.includes("desktop")) {
        this.desktop = true;
        this.mobile = false;
      }
      if (aMQBridge.includes("mobile")) {
        this.mobile = true;
        this.desktop = false;
      }

      // mode=app?
      if (this.$store.getters.hasApp) {
        aMQBridge.push("is-app");
      } else {
        aMQBridge.push("is-web");
      }

      // check for a notch!
      if (
        parseFloat(getComputedStyle(eMQBridge.querySelector("#notch")).height)
      ) {
        aMQBridge.push("notch");
      } else {
        aMQBridge.push("box");
      }

      this.notice(`MQBRIDGE > BODY: `, ...aMQBridge);

      this.iRandTrigger = Math.random() + 1;

      // toggle out the last set and update..
      document.body.classList.remove(...this.aMQBridgePrevious);
      document.body.classList.add(...aMQBridge);

      this.aMQBridgePrevious = aMQBridge;

      // accessibility & theme (darkmode etc)
      let sMQAccess = getComputedStyle(eMQBridge, ":after").content.replace(
        /^\W(.*)\W$/,
        "$1"
      );
      let aMQAccess = sMQAccess.split(" ");

      let sPref = this.$userEngine.getPref("layout.theme");
      // if (this.forceDark) {

      // console.log(`DLM: ${this.forceDark} || !${sPref} (${sPref})`);
      if (this.forceDark) { // || (!sPref)) {
        sPref = "darkmode";
      }
      // this.notice(`Theme preference: ${sPref}`);

      // for now, we're only expecting ['darkmode'] or ['lightmode]
      if (sPref && sPref != "auto") {
        aMQAccess[0] = sPref;
      }

      // framehacked?
      if (document == top.document) {
        aMQAccess.push("top-frame");
      } else {
        aMQAccess.push("in-frame");
      }

      /**
       * hardcoded accessibility things.
       */

      // toggle all gamification (the dial)

      this.$userEngine.getPref("a11y.dial.off")
        ? aMQAccess.push("a11yDialOff")
        : null;

      document.documentElement.classList.remove(
        ...document.documentElement.classList
      );
      document.documentElement.classList.add(...aMQAccess);

      this.aMQAccess = aMQAccess;
    },

    nourishDeskBounce() { // (to = false, why = "?") {
      return;
      // // given ... or assumed?
      // to = to || this.$route;

      // // already in a frame?
      // let bFramed = false;
      // try {
      //   bFramed = window.self !== window.top;
      // } catch (e) {
      //   bFramed = false;
      // }

      // this.notice(
      //   `[BounceHandler] :: [${why}] Checking bounce: ${to.path} (Framed: ${bFramed})`,
      //   to.path,
      //   this.$dq,
      //   this.inFrameDevices.includes(this.$dq),
      //   to
      // );

      // if (bFramed) {
      //   this.nourishDeskBounceOut(to);
      // } else {
      //   let bChromeRoute = to.path.search(/^\/d\//) == 0;
      //   if (bChromeRoute && this.inFrameDevices.includes(this.$dq)) {
      //     this.nourishDeskBounceOut(to);
      //   } else {
      //     this.nourishDeskBounceIn(to);
      //   }
      // }
    },

    nourishDeskBounceOut() { // (to) {
      return;
      // let bFrameableRoute = to.path.search(/^\/n\//) == 0; //  || (to.path == '/');

      // if (!bFrameableRoute) {
      //   this.notice(`[BounceHandler] :: Redirecting [TOP] ---> ${to.path}`);
      //   // console.warn({doc: document, to: to});
      //   window.top.location.href = to.path.replace(/^\/d\//, "/n/"); // we actually do want this in the history
      //   return;
      // }
    },

    nourishDeskBounceIn() { // (to) {
      return;
      // return to == "false";

      // this.notice(`[BounceHandler] :: ${to.path} == Object ::`, this.$mq);
      // // we're already mobile ... stick with it ..
      // if (this.inFrameDevices.includes(this.$dq)) {
      //   this.notice(`[BounceHandler] :: ${to.path} == Ignore ---> (mq:${this.$dq})`);
      //   return this.$dq;
      // }
      // this.notice(`[BounceHandler] :: ${to.path} == Consider ?? (mq:${this.$mq})`);

      // // do we recognise the route? /n/foo
      // let bStackPath = (to.path.search(/^\/n\//) == 0);
      // if (!bStackPath) {
      //   this.notice(`[BounceHandler] :: ${to.path} == Ignore ---> ${bStackPath}`);
      //   return 'path';
      // }

      // let bDeskPath = (to.path.search(/^\/d\//) == 0);
      // if (bDeskPath) {
      //   this.notice(`[BounceHandler] :: ${to.path} == Ignore ---> (desk)`);
      //   return 'desk';
      // }

      // let sPath = '/d';

      // if (bStackPath) {
      //   // okay - we're desktop (or medium?) .. and we're not framed ... we're on a swiper-looking URL ... so let's bounce!
      //   sPath = to.fullPath.replace(/^\/n\//, '/d/'); //  + (Object.keys(to.query).length ? '?' + new URLSearchParams(to.query).toString() : '');
      // }

      // // go!
      // this.notice(`[BounceHandler] :: ${to.path} == Redirecting ---> ${sPath}`);
      // // tor.push(sPath);
      // top.location.replace(sPath);

      // // and stop the mount?
      // return false;
    },

    notice() {
      // console.log(`\x1B[36m LayoutEngine --`, ...arguments);
    },

    error() {
      console.error(`\x1B[36m LayoutEngine --`, ...arguments);
    },
  }, // end methods

  created() {
    // watch MQBridge mutations for body class
    // this.notice("Created");
    // this.syncMQBridge();

    // setup!
    this.windowWidth = window.innerWidth;

    // debounced resize listener.. (300ms)
    window.addEventListener("resize", () => {
      // not reactive really..
      this.windowWidth = window.innerWidth;
      // debonce the bridge & redirect
      if (this.tResize) {
        window.clearTimeout(this.tResize);
        // check our bounce state
        // this.nourishDeskBounce(this.$route, 'resize');
      }
      this.tResize = window.setTimeout(this.syncMQBridge, 300);
    });

    window.addEventListener("blur", this.syncMQBridge);
    window.addEventListener("focus", this.syncMQBridge);

    // also recheck when the user reloads (for layout preferences)
    this.EventBus.$on("api:account", this.syncMQBridge);
    this.EventBus.$on("user:prefs", this.syncMQBridge);

    this.EventBus.$on("router:beforeEach", (oArgs) => {
      this.notice(`[BounceHandler] :: EVENT :: `, oArgs);
      // this.nourishDeskBounce(oArgs.to, 'event');
    });
  },

  watch: {
    $route() {
      //to
      this.syncMQBridge();
      // this.nourishDeskBounce(to, 'watch');
    },
    viewMode() {
      this.syncMQBridge();
    },
  },
});

Object.defineProperties(Vue.prototype, {
  $layoutEngine: {
    get: function () {
      return layoutEngine;
    },
  },
});
